// src/features/owner/sections/analytics/GrowthSection.tsx
import { AnalyticsSection } from './AnalyticsSection';
export const GrowthSection = () => <AnalyticsSection kind="growth" />;
